export default {
  title: {
    id: 'recommendation_cross_sell_title',
    defaultMessage: 'Plays nice with',
  },
}
